import { Component, OnInit, OnDestroy } from '@angular/core';
import { MaterialImports } from '../../material.imports';
import { Router, RouterOutlet, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { QrScannerButtonComponent } from '../../components/qr-scanner-button/qr-scanner-button.component';
import { NotificationService } from '../../services/notification.service';
import { LoggerService } from '../../core/logger.service';
import { BottomNav } from '../../components/bottom-nav/bottom-nav';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [
    ...MaterialImports,
    RouterOutlet,
    QrScannerButtonComponent,
    BottomNav,
  ],
  templateUrl: './home-layout.html',
  styleUrl: './home-layout.scss',
})
export class HomeLayout implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    const token = this.authService.getToken();
    if (!token) {
      this.redirectToLogin();
      return;
    }

    // Initialize SignalR for real-time notifications
    // JWT claims: UserId (numeric), UserTypeId (group), UserCode (AgentCode like A0061)
    // IMPORTANT: SignalR must register with UserCode (not UserId) because
    // notifications are sent to alert_to_user which uses AgentCode (e.g., A0061)
    const decoded = this.authService.decodeToken() as any;
    if (decoded?.UserCode && decoded?.UserTypeId) {
      this.notificationService.initializeSignalR(decoded.UserCode, decoded.UserTypeId);
      this.logger.log('[HomeLayout] SignalR initialized for user:', decoded.UserCode, 'type:', decoded.UserTypeId);
    } else if (decoded?.UserId && decoded?.UserTypeId) {
      // Fallback to UserId if UserCode not available (shouldn't happen for agents)
      this.notificationService.initializeSignalR(decoded.UserId.toString(), decoded.UserTypeId);
      this.logger.warn('[HomeLayout] UserCode not found, using UserId:', decoded.UserId);
    } else {
      this.logger.warn('[HomeLayout] Missing UserCode/UserId or UserTypeId in token:', decoded);
    }
  }

  ngOnDestroy(): void {
    // Stop SignalR when leaving the app
    this.notificationService.stopSignalR();
  }

  redirectToLogin() {
    const queryParams = this.route.snapshot.queryParams;
    this.router.navigate(['/login'], { queryParams });
  }
}
